module.exports = __webpack_public_path__ + "img/7.IG-2.12455624.jpg";